import React from "react";
import "./Menu.css";
import Myself from "./Me.jpg";
import Fade from "react-reveal/Fade";
import Zoom from "react-reveal/Zoom";

const Menu = () => {
  return (
    <>
      <section id="menu">
        <div className="Intro">
          <Fade left>
            <div id="name">
              <label id="hello">Hello!</label>, I'm{" "}
              <b>
                Suleiman Mustapha <b id="web"> >Developer </b>
              </b>
            </div>
          </Fade>
        </div>
        <Fade left>
          <div className="work">
            <label id="do">
              <b>Web-Dev</b>
            </label>
          </div>
        </Fade>

        <div className="photo">
          <img src={Myself} id="Me" alt="suleiman"></img>
        </div>

        <div className="sociallinks">
          <a href="https://github.com/codewithsul" target="_blank" >
            <i class="bx bxl-github icon1"></i>
          </a>
          <br></br>
          <a href="https://instagram.com/jabariinks" target="_blank" >
            <i class="bx bxl-instagram icon"></i>
          </a>

          <br></br>
          <a href="https://twitter.com/hidrabeast" target="_blank" >
            <i class="bx bxl-twitter icon"></i>
          </a>
          <br></br>
          <a href="https://wa.me/255734075867" >
            <i class="bx bxl-whatsapp icon"></i>
          </a>
        </div>
      </section>
    </>
  );
};

export default Menu;
